/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ThemeProvider } from '@stashinvest/ui';
import UniversalOnboardingGraph from './UniversalOnboardingGraph';
import {
	SignUpContent as Content,
	SignUpLayout as Layout,
} from 'stash/components/global';

import { useAnalytics } from 'stash/hooks/useAnalytics';
import { useTrack } from 'stash/hooks/useTrack';
import { getSearchParameters } from '../utils';
import { setIdvReturnParam } from 'stash/actions';
import { RETURN_TO_KEY, RETURN_TO_VALUE } from 'stash/constants/identityVerification';
import SignUpGraphComponent, { SignUpGraphComponentProps } from 'stash/graph/SignUpGraph';
import { GlobalHeader } from './GlobalHeader';
import { EXPERIMENTS, useIsInExperimentVariation } from 'stash/components/experiments';
import UniversalOnboardingGraphVariation from './OnboardingGraphVoAM1';

const SignUpLayout = Layout as React.FC<{ children?: React.ReactNode }>;
const SignUpContent = Content as React.FC<{ children?: React.ReactNode }>;
const SignUpGraph = SignUpGraphComponent as React.FC<SignUpGraphComponentProps>;

type OwnProps = {
	ready: boolean,
	theme: { name: string },
	product: string,
	uuid: string,
}

const AuthenticatedOnboardingAppUI = ({ ready, theme, product, uuid }: OwnProps) => {
	const analytics = useAnalytics();
	const track = useTrack();
	const dispatch = useDispatch();

	if (getSearchParameters(RETURN_TO_KEY) === RETURN_TO_VALUE) {
		dispatch(setIdvReturnParam(true));
	}

	const isInVoiceOfAdvisorVariation = useIsInExperimentVariation(
		EXPERIMENTS.VOICE_OF_THE_ADVISOR_V1,
		true
	);

	useEffect(() => {
		if (ready && uuid) {
			//@ts-ignore useAnalytics is not typed, expecting an identify method.
			void analytics.identify(uuid, {}, { context: { stash_clean: true } });
		}
	}, [ready, uuid, analytics, track]);

	const graph = isInVoiceOfAdvisorVariation ? UniversalOnboardingGraphVariation : UniversalOnboardingGraph;

	return (
		<ThemeProvider mode={theme.name}>
			<GlobalHeader />
			<SignUpLayout>
				<SignUpContent>
					{ready && <SignUpGraph product={product} graph={graph} />}
				</SignUpContent>
			</SignUpLayout>
		</ThemeProvider>
	);
};

export default AuthenticatedOnboardingAppUI;
